<template>
    <div class="guest-layout">
      <router-view />
    </div>
  </template>
  
  <script>
  export default {}
  </script>
<style scoped>
.guest-layout{
 width: 100%;
 background-color: black;
}
</style>
